export const DEFAULT_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
export const DEFAULT_ACCEPT = 'image/*,video/*';
